import React, {useEffect, useState} from "react";
import BankFormWizard from "../../components/form/BankFormWizard";
import {useCreateBankMutation} from "../../../../../redux/apiSlice";
import {useSubheader} from "../../../../../_metronic/layout";
import cogoToast from "cogo-toast";

export const CreateBank = ({history, location}) => {
    const subheader = useSubheader();
    useEffect(() => {
        subheader.setTitle("Create Bank")
    }, [subheader])

    const [tab, setTab] = useState(1);

    const [
        createBank, // This is the mutation trigger
        {
            isLoading: isCreating,
            isSuccess: createdSuccessfully,
        }, // This is the destructured mutation result
    ] = useCreateBankMutation()

    /* Clear fields on success */
    useEffect(() => {
        if (createdSuccessfully) {
            cogoToast.success("Created 'Bank Creation' Action Successfully")
            setTab(1)
            history.push("/overview/banks/create")
        }
    }, [history, createdSuccessfully]);

    /* Submit exchange rate data */
    const submitData = async data => {
        createBank(data);
    }

    return (
        <BankFormWizard
            key={location.key}
            tab={tab} // Reset Tab on success
            setTab={setTab}
            isLoading={isCreating}
            submitData={submitData}
        />
    )
}